module.exports = 'react-ansi-style-';



//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/react-ansi-style/default-css-prefix.js
// module id = 1548
// module chunks = 3